module.exports = __webpack_public_path__ + "static/media/success.d5fa6768.svg";